<template>
  <b-row>
    <b-col cols="4">
      <BfInput
        label="Nº de encargo"
        data-key="encargo_numero"
        :value="data.encargo_numero"
        :errors="errors"
        readonly
      />
    </b-col>

    <b-col cols="4">
      <BfInput
        label="Cliente"
        data-key="encargo_cliente_nombre"
        :value="data.encargo_cliente_nombre"
        :errors="errors"
        readonly
      />
    </b-col>
    <!--this is only visible on create-->
    <b-col v-if="!editing" cols="4">
      <BfInput
        label="Expediente"
        data-key="encargo_expediente"
        :value="data.encargo_expediente"
        readonly
      />
    </b-col>

    <b-col cols="4">
      <BfDatePicker
        label="Abierta desde *"
        data-key="fecha_hora_creacion"
        :value="data.fecha_hora_creacion"
        value-format="yyyy-MM-dd HH:mm:ss"
        :errors="errors"
        @update="updateForm"
      />
    </b-col>

<!--segunda fila-->

    <b-col cols="4">
      <BfSelect
        label="Tasador encargado"
        data-key="tasador_asignado_id"
        :value="data.tasador_asignado_nombre"
        :edit-mode="editing"
        :errors="errors"
        :options="assessorSelectOptions"
        @update="updateForm"
      />
    </b-col>


    <b-col cols="4">
      <BfSwitch
        :value="data.externo"
        label="Externo"
        data-key="externo"
        @update="updateForm"
      />
    </b-col>


    <b-col cols="12">
      <BfInput
        label="Motivo *"
        data-key="motivo"
        :value="data.motivo"
        :edit-mode="editing"
        :errors="errors"
        @update="updateForm"
        type="textarea"
        :autosize="{ minRows: 5, maxRows: 10 }"

      />
    </b-col>

    <b-col cols="12" class="pt-2">
      <label class="small d-block mb-1 text-secondary">
        Resuelta en: <template v-if="data.estaResuelta">
          <strong>{{formatedResolveDate}}</strong>
        </template>
        <template v-else>–</template>
      </label>
      <BfSwitch
        :value="data.estaResuelta"
        data-key="estaResuelta"
        :left-border="false"
        :display-label="false"
        @update="updateForm"
      />
    </b-col>


    <!--cerrada-->
    <b-col cols="12" class="pt-3">
      <label class="small d-block mb-1 text-secondary">
        Cerrada en: <template v-if="data.estaCerrada">
          <strong>{{formattedCloseDate}}</strong>
        </template>
        <template v-else>–</template>
      </label>
      <BfSwitch
        :value="data.estaCerrada"
        data-key="estaCerrada"
        :left-border="false"
        :display-label="false"
        @update="updateForm"
      />
    </b-col>

  </b-row>
</template>

<script>
import { moment } from '@/utils';

export default {
  name: 'RetainedForm',

  props: {
    data: {
      type: Object,
      default: () => ({}),
    },

    editing: {
      type: Boolean,
      default: false,
    },

    errors: {
      type: Object,
    },

    assessorSelectOptions: {
      type: Array,
    },

    typeSelectOptions: {
      type: Array,
    },
  },

  methods: {
    updateForm(fieldData) {
      this.$emit('update', fieldData);
    },

    updateFormCheckbox(value, key) {
      this.updateForm({
        value,
        key,
      });
    },
  },

  computed: {
    formatedResolveDate() {
      if (this.data.fecha_hora_resolucion) {
        return moment(this.data.fecha_hora_resolucion).format('DD-MM-YYYY HH:mm:ss');
      }

      return '';
    },

    formattedCloseDate() {
      if (this.data.fecha_hora_cerrada) {
        return moment(this.data.fecha_hora_cerrada).format('DD-MM-YYYY HH:mm:ss');
      }

      return '';
    },
  },
};
</script>
